export default __webpack_public_path__ + "static/Cervejas-bud-2-28ffef426ac75e24c17bb7b433f2e3b4.jpg";